import { AdvFilterCommand, AdvFilterPicker, AdvFilterResult } from "components/AdvFilter";
import { CmdActiveOnly, CmdDeepTeam, CmdInstitutional, CmdOnlyInstitutional, CmdPost, CmdQuestion, CmdTopic, CmdTopicNoSubs, CmdWithVideo, CommandLabels } from "components/AdvFilter/CommonCommands";
import { DashboardGraphModel, DashboardUserAndGroupsFilter, DashboardUserAndGroupsParticipationSummaryColumn } from "models/ApiModels";
import { RenderTopicModelListEvents } from "views/Dashboards/components/RenderTopicModelList";
import { RenderUserModelListEvents } from "views/Dashboards/components/RenderUserModelList";

/////////////////////////////////////////////////////////////////////////////////////

export enum ParticipationGraphPeriod { Last7, Last30, Last12 }

export enum ParticipationListAccessPeriod { Last7, Last30, Day }

export enum ParticipationListPublicationPeriod { Last30, All }

export interface IParticipationGraphProps extends RenderUserModelListEvents, RenderTopicModelListEvents {
    tile: DashboardUserAndGroupsParticipationSummaryColumn;
    filter: DashboardUserAndGroupsFilter;
}

export interface IParticipationGraphState {
    data: DashboardGraphModel[];
    loading: boolean;
    tabOption?: ParticipationGraphPeriod;
    selectedDay?: Date;
}


export interface IParticipationListProps extends RenderUserModelListEvents, RenderTopicModelListEvents {
    tile: DashboardUserAndGroupsParticipationSummaryColumn;
    filter: DashboardUserAndGroupsFilter;
    graphPeriod: ParticipationGraphPeriod;
    selectedDay: Date;
    onCancelDay: () => void;
}

export type UserAndGroupsCommandTypeDef = {
    key: string;
    commands: AdvFilterCommand[];
};

export interface IUserAndGroupsFilterProps {
    commandTypeDef: UserAndGroupsCommandTypeDef;
    onFilterChange: (filter: AdvFilterResult[]) => void;
    advFilters: AdvFilterResult[];
}


function DashboardUserAndGroupsCommands(): AdvFilterCommand[] {
    const cmdLabels = CommandLabels();
    return [
        { keyword: CmdTopic, displayName: cmdLabels[CmdTopic], picker: AdvFilterPicker.Topic, group: 1, canRepeat: false},
        { keyword: CmdTopicNoSubs, displayName: cmdLabels[CmdTopicNoSubs], group: 1, canRepeat: false },
        { keyword: CmdPost, displayName: cmdLabels[CmdPost], picker: null, group: 2 },
        { keyword: CmdQuestion, displayName: cmdLabels[CmdQuestion], picker: null, group: 2 },
        { keyword: CmdWithVideo, displayName: cmdLabels[CmdWithVideo], group: 3, canRepeat: false },
        { keyword: CmdInstitutional, displayName: cmdLabels[CmdInstitutional], group: 4, optionGroup: "Institutional" },
        { keyword: CmdOnlyInstitutional, displayName: cmdLabels[CmdOnlyInstitutional], group: 4, optionGroup: "Institutional" },
        { keyword: CmdActiveOnly, displayName: cmdLabels[CmdActiveOnly], group: 4, canRepeat: false },
    ];
}

function DashboardUserAndGroupsAnswerFilterCommands(): AdvFilterCommand[] {
    const cmdLabels = CommandLabels();
    return [
        { keyword: CmdTopic, displayName: cmdLabels[CmdTopic], picker: AdvFilterPicker.Topic, group: 1, canRepeat: false },
        { keyword: CmdTopicNoSubs, displayName: cmdLabels[CmdTopicNoSubs], group: 1, canRepeat: false },
        { keyword: CmdWithVideo, displayName: cmdLabels[CmdWithVideo], group: 3, canRepeat: false },
        { keyword: CmdActiveOnly, displayName: cmdLabels[CmdActiveOnly], group: 4, canRepeat: false },
    ];
}

export function DashboardUserAndGroupsAnswerCommands(): UserAndGroupsCommandTypeDef {
    return {
        key: "DashboardUserAndGroupsAnswerCommands",
        commands: DashboardUserAndGroupsAnswerFilterCommands()
    };
}


export function DashboardUserAndGroupsKnowledgeTestCommands(): UserAndGroupsCommandTypeDef {
    return {
        key: "DashboardUserAndGroupsKnowledgeTestCommands",
        commands: DashboardUserAndGroupsCommands().filter(p => p.group == 1)
    };
}

export function DashboardUserAndGroupsTeamCommands(): UserAndGroupsCommandTypeDef {
    const cmdLabels = CommandLabels();
    return {
        key: "DashboardUserAndGroupsTeamCommands",
        commands:
            [
                { keyword: CmdDeepTeam, displayName: cmdLabels[CmdDeepTeam], picker: null, group: 1, canRepeat: false },
                ...DashboardUserAndGroupsCommands(),
            ]
    };
}

export function DashboardUserAndGroupsTeamKnowledgeTestCommands(): UserAndGroupsCommandTypeDef {
    return {
        key: "DashboardUserAndGroupsTeamKnowledgeTestCommands",
        commands: DashboardUserAndGroupsTeamCommands().commands.filter(p => p.group != 2 && p.group != 3)
    };
}

export function DashboardUserAndGroupsKnowledgeCommands(): UserAndGroupsCommandTypeDef {
    return {
        key: "DashboardUserAndGroupsKnowledgeCommands",
        commands: [
            ...DashboardUserAndGroupsCommands(),
        ]
    };
}